import { request } from "./client";

export const contactApi = {
  send: (formData, language) =>
    request("/api/contactme/", { method: "POST", body: formData, language }),

  newsletter: (email, language) =>
    request("/api/newsletter/create/", {
      method: "POST",
      body: JSON.stringify({ email, is_subscribed: true }),
      language,
    }),
};
